import About from "../Components/About";
import SectionOne from "../Components/SectionOne";
import SectionTwo from "../Components/SectionTwo";
import SectionThree from "../Components/SectionThree";
import SectionFour from "../Components/SectionFour";
import SectionFive from "../Components/SectionFive";
import SectionSix from "../Components/SectionSix";

const Content = () => {
  return (
    <>
      <About />
      <SectionTwo />
      <SectionThree />
      <SectionSix />
      <SectionFour />
      <SectionFive />
      {/* <SectionOne /> */}
      {/* Other sections .. */}
    </>
  );
};

export default Content;
